export default {
  button: {
    schedule: "Schedule now",
    scheduling: "Scheduling...",
    login: "Login",
    premium: "Get Apostle Premium",
    premium_small: "Apostle Premium"
  },
  langhint: {
    nl: "Switch to Dutch",
    en: "Current language is English"
  },
  wall: {
    title: "Inspiration wall",
    summary:
      "Here’s an overview of content already shared with Apostle Connect",
    readmore: "read more"
  },
  form: {
    post: {
      label: "Post content",
      placeholder: "Create your own post",
      error: "Please fill in some text"
    },
    receivers: {
      label: "Your colleagues' email addresses separated by spaces (max. 10)",
      placeholder: "E-mail address...",
      error: {
        empty: "Please fill in some e-mail addresses",
        maximum: "You cannot fil in more than 10 e-mail addresses"
      }
    },
    name: {
      label: "Your first name",
      placeholder: "First name",
      error: "Please fill in your name"
    },
    email: {
      label: "Your email address (will be added to the list)",
      placeholder: "E-mail address",
      error: {
        empty: "Please fill in your e-mail address",
        listed: "Your own e-mail address will already be added to the list",
        invalid: "Please fill in a valid e-mail address",
        company: "Only company e-mail addresses are allowed"
      }
    },
    text: {
      more: "Want to share with more than 10 colleagues?",
      link: "Try Apostle Connect now!",
      done: {
        title: "You're all done!",
        text: {
          line_one:
            "Your colleagues will instantly receive an e-mail with instructions on how to continue",
          line_two:
            "They can now easily share your post to their social media channels of choice.",
          line_three: "Want to know more about our software?"
        },
        link: "Please find out about our other features here"
      }
    },
    api: {
      error: {
        first: "Oh no, something went wrong, please try again!",
        multiple:
          "Something is still not working...\r\nMaybe you could contact our Technical Support!"
      }
    }
  }
};
